export const environment = {
  gqlUrl: 'https://ms-gateway.api.unipin.com/graphql',
  indiaGqlUrl: 'https://ms-gateway.api-india.unipin.com/graphql',
  
  voucherRedirectUrl: 'https://ms-pci-voucher.api.unipin.com',
  otelCollectorUrl: 'https://ms-otel-trace-proxy.api.unipin.com/v1/traces',

  tazapayApiKey: 'pk_HUeKhYyOM3frVO3B16Oq',
  firebaseConfig: {
    apiKey: "AIzaSyBc6HWc52ndHfxhaYwnIf58dGwC82tVj1U",
    authDomain: "unipin-nextgen-prod.firebaseapp.com",
    projectId: "unipin-nextgen-prod",
    storageBucket: "unipin-nextgen-prod.firebasestorage.app",
    messagingSenderId: "1006491677153",
    appId: "1:1006491677153:web:163b10204255a0ea2a62a0"
  },
};
